import { render, staticRenderFns } from "./DisplayView.vue?vue&type=template&id=a0449534&"
import script from "./DisplayView.ts?vue&type=script&lang=ts&"
export * from "./DisplayView.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports